











































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'


@Component({
  components: {
    Card,
  }
})
export default class StorybookSelect extends Vue {
  get items() {
    return [
      {
        name: 'Option 1',
        id: '1',
      },
      {
        name: 'Option 2',
        id: '2',
      },
      {
        name: 'Option 3',
        id: '3',
      }
    ]
  }
}
